import { createSlice } from "@reduxjs/toolkit";

const technicalTicket = createSlice({
  name: "technical-ticket",
  initialState: {
    value: {
      tickets: [],
      trackedTicket: {},
      status: 200
    }
  },
  reducers: {
    setTechnicalTicketReducer(state, {payload}){
      state.value.tickets = payload
    },
    setTrackedTicket(state, {payload}) {
      state.value.trackedTicket = payload
    },
    setStatus(state, {payload}) {
      state.value.status = payload
    }
  }
})

export const { setTechnicalTicketReducer, setTrackedTicket, setStatus} = technicalTicket.actions
export default technicalTicket.reducer